"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeRenewalCoversTree = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var commonFunctions_1 = require("../../../helpers/commonFunctions");
var CoversHelper_1 = require("../../../helpers/CoversHelper");
var services_1 = require("@falcon/services");
var Tree_1 = require("../../../components/Tree");
var HomeRenewalCoversTree = /** @class */ (function (_super) {
    __extends(HomeRenewalCoversTree, _super);
    function HomeRenewalCoversTree(props) {
        var _this = _super.call(this, props) || this;
        _this.coverTypes = {
            BUILDINGS_CONTENTS: "Buildings and Contents",
            HOME_EMERGENCY: "Home Emergency",
            HOME_LEGAL_EXPENSES: "Home Legal Expenses"
        };
        _this.excessTypes = {
            SUBSIDENCE_LANDSLIP_HEAVE_EXCESS: "Subsidence, Landslip or Heave Excess",
            ESCAPE_OF_WATER_EXCESS: "Escape of Water Excess",
            FLOOD_EXCESS: "Flood Excess",
            HOME_EXCESS: "Other Home Excess"
        };
        _this.state = {};
        return _this;
    }
    HomeRenewalCoversTree.prototype.render = function () {
        var coverages = [];
        for (var _i = 0, _a = this.props.interaction.covers; _i < _a.length; _i++) {
            var cover = _a[_i];
            coverages.push((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "".concat(this.coverTypes[cover.type], " ").concat((0, commonFunctions_1.getAmountToDisplay)(this.getTotalCoverAmount(cover))), children: [this.renderExcesses(cover), this.renderLimits(cover), (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Insurance Premium Tax ", this.getIptAmount(cover)] }) })] }, cover.type));
        }
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: coverages }));
    };
    HomeRenewalCoversTree.prototype.renderExcesses = function (cover) {
        var excesses = [];
        for (var _i = 0, _a = cover.amounts; _i < _a.length; _i++) {
            var amount = _a[_i];
            if (amount.type in this.excessTypes) {
                excesses.push((0, jsx_runtime_1.jsxs)("div", { children: [this.excessTypes[amount.type], " ", (0, commonFunctions_1.getAmountToDisplay)(amount.amount)] }));
            }
        }
        if (excesses.length > 0) {
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Excesses", children: excesses.map(function (x, i) {
                    return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: x }, "Excesses-".concat(i));
                }) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    HomeRenewalCoversTree.prototype.renderLimits = function (cover) {
        var limits = [];
        for (var _i = 0, _a = cover.amounts; _i < _a.length; _i++) {
            var amount = _a[_i];
            if (CoversHelper_1.CoversHelper.limitRegex.test(amount.type) && amount.type in CoversHelper_1.CoversHelper.homeLimitTypes) {
                limits.push((0, jsx_runtime_1.jsxs)("div", { children: [CoversHelper_1.CoversHelper.homeLimitTypes[amount.type], " ", CoversHelper_1.CoversHelper.getAmountWording(this.props.interaction.coverTier, amount.type, amount.amount)] }, amount.type));
            }
        }
        if (limits.length > 0) {
            if (this.props.interaction.coverTier !== services_1.BRONZE_TIER) {
                limits.push(CoversHelper_1.CoversHelper.getProfessionalRemovalDiv());
            }
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Limits", children: limits.map(function (x, i) {
                    return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: x }, "Limits-".concat(i));
                }) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    HomeRenewalCoversTree.prototype.getTotalCoverAmount = function (cover) {
        var coverAmount = 0;
        for (var _i = 0, _a = cover.amounts; _i < _a.length; _i++) {
            var amount = _a[_i];
            if (amount.type === "PREMIUM" || amount.type === "IPT_TAX") {
                coverAmount = coverAmount + amount.amount;
            }
        }
        return coverAmount;
    };
    HomeRenewalCoversTree.prototype.getIptAmount = function (cover) {
        return (0, commonFunctions_1.getAmountToDisplay)(cover.amounts.filter(function (amount) { return amount.type === "IPT_TAX"; })[0].amount);
    };
    return HomeRenewalCoversTree;
}(React.Component));
exports.HomeRenewalCoversTree = HomeRenewalCoversTree;
//# sourceMappingURL=HomeRenewalCoversTree.js.map